<template>
  <div class="updatSeting">
    <div class="card-body">
      <div id="upload-container" class="text-center">
        <button id="browseFile" ref="browseFile" class="btn btn-primary">Chọn File (Chỉ nhận file .mp4)</button>
      </div>
      <el-progress :percentage="percentage"></el-progress>
      <iframe :src="link_video" title="W3Schools Free Online Web Tutorials"></iframe>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'TestUploadVideo',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'TestUploadVideo'
    }
  },
  data () {
    return {
      canSubmit: true,
      percentage: 0,
      link_video: ''
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configs-home', text: 'Test Upload Video' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    updateProgress (t) {
      this.percentage = t
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.list-question {
  min-height: 100vh;
}
.item-question {
  margin-bottom: 15px;
}
.index {
  font-size: 18px;
}
.content-question {
  color: green;
  font-weight: bold;
  margin-bottom: 15px;
}
.item-option {
  margin-bottom: 5px;
}
.content-option {
  margin-left: 10px;
}
.item-link {
  margin-left: 10px;
  display: inline-block
}
</style>



// WEBPACK FOOTER //
// src/components/config-home/TestUploadVideo.vue